<template>
    <BaseLayout> 
     <!-- 主内容 -->
     <div> 
       
       <TitleModel
             :title="'经济舱'"
             :content="'  '" /> 
 
       <!-- princess -->
       <div class="wp-relative">   
         <div class="dt-css-grid"> 
           
           <div class="wf-cell" v-for="aitem in productList" :key="aitem.id">
             <article>
               <div class="wf-cell-img" >
                 <a class="wf-cell-link" @click="alinkFun(aitem.id)">
                   <el-image
                   style="width: 100%; height: 100%"
                   :src="baseURL+aitem.urlimage"
                   :fit="fit" 
                   ></el-image>
                 </a> 
               </div>
 
               <div class="wf-cell-desc">
                 <h3> <a  @click="alinkFun(aitem.id)" target  :title="'img11 --'" rel="bookmark">{{ aitem.title }}</a></h3>
                 <div>
                   <p>{{aitem.desc }}</p>
                 </div>
               </div>   
             </article> 
           </div> 
         </div>  
           
       </div>        
         
        
       <TitleModel
             :title="'联系方式'"
             content="欢迎通过以下方式联系我们，365天全年无休。" 
             content2="温柔贴心女客服（小爱/红豆）竭诚为您服务。"
             content3="我们的营业时间是11Am-2Am，如需预约此时段外，请提前联系。"/> 
       <!-- contact -->
       <CommContact />
     </div>
      
   </BaseLayout>
 
 </template>
 
 
 
 <script>
 import {mapState,mapMutations} from 'vuex';
 import BaseLayout from '@/components/BaseLayout.vue';
 import TitleModel from '@/components/TitleModel.vue';
 import CommContact from '@/components/CommContact.vue';
 export default { 
    name:'PrincessPage',
   props: {
     msg: String
   },
   components: { 
     BaseLayout, 
     TitleModel, 
     CommContact
   },
   data() {
     return {
       showModal: false,
       fit:'cover',
       baseURL:this.$store.state.apiUrl,//'https://api2.seattletaotao.com',
       getUrl:'/api/princess/getList' 
     };
   } ,
   computed: {
     ...mapState(['productList','princessIndex']) 
   },
   methods: {
     ...mapMutations(['setPrincessIndex']),
     alinkFun(pid) {
       this.$local.setItem('pid',pid);
       this.setPrincessIndex(pid);
       this.$router.push({ path: '/product'}); //, params: { pid: pid}
     }
   }
 }
 </script>
 
 <!-- Add "scoped" attribute to limit CSS to this component only -->
 <style lang="scss" scoped>
 @import url(@/assets/css/commPage.scss);
 
 .wf-cell-desc{
   z-index: 10;
   padding: 15px 10px 10px 10px !important;
   
   h3{
     font-size: 22px !important;
     color: #F3E69E !important;
     margin-top: 0;
     margin-bottom: 5px;
     text-transform: none;
     clear: none;
     a{
       color: #fbedcd;
       display: inline-block;
       -webkit-transition: none;
       transition: none;
     }
   }
   div{
     font-weight: 1000;
     background: -webkit-linear-gradient(43deg, #c1924e, #f6eca5 80%) !important;
     -webkit-background-clip: text !important;
     -webkit-text-fill-color: transparent;
   }
 
 }
    
 .wf-cell-link{
   position: relative;
   display: block;
   line-height: 0;
   overflow: hidden;  
   height: 100%;
   width: 100%;
 }
 .wf-cell-link .el-image:hover{ 
     transform: scale(1.3);
     transition: transform 0.6s ease;
     -webkit-transition: -webkit-transform .6s ease-out, opacity .6s;
     transition: transform .6s ease-out, opacity .6s;
     -webkit-backface-visibility: hidden;
     backface-visibility: hidden; 
 } 
 
 h3 {
   margin: 40px 0 0;
 }
 ul {
   list-style-type: none;
   padding: 0;
 }
 li {
   display: inline-block;
   margin: 0 10px;
 }
 a {
   color: #42b983;
 }
 </style>
 